export default "__VITE_ASSET__$J5pQexj__"